import { createRouter, createWebHistory } from 'vue-router';
export const loadView = (view) => {
    return () => import(/* webpackChunkName: "view-[request]" */ `@/components/pages/${view}.vue`);
};
const routes = [
    {
        path: '/',
        component: loadView('InitLoadingMain'),
        redirect: '/trade',
    },
    {
        path: '/trade',
        name: 'Main',
        component: loadView('InitLoadingMain'),
    },
    {
        path: '/members/sign_in',
        name: 'Login',
        component: loadView('Login'),
    },
    {
        path: '/members/connect',
        name: 'Connect',
        component: loadView('Connect'),
    },
    {
        path: '/:notFound(.*)',
        component: loadView('InitLoadingMain'),
        redirect: '/trade',
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
export default router;
